import { TableHead, TableRow, TableCell, useTheme, Checkbox, Box, TableSortLabel } from '@mui/material';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { useLocation } from 'react-router-dom';
import { getTabColorHeaderMain } from '../../shared/constants/constants';
import {
  ContentLogKeys,
  EngagementKeys,
  IssueAndServiceSharedValues,
  IssueKeys,
  ServiceKeys,
} from '../../shared/constants/IssueAndServiceKeys';

// TODO: Add unit test to make sure they are correct subarrays from constants.js
// Also tests to make sure the same column isn't in Media and Service at some time
const wide1ColsMap = {
  MediaInteraction: [IssueKeys.campaign],
  ServiceLog: [ServiceKeys.campaign],
  EngagementLog: [EngagementKeys.campaign],
  ContentLog: [ContentLogKeys.campaign],
};

const wide2ColsMap = {
  MediaInteraction: [IssueKeys.topic],
  ServiceLog: [ServiceKeys.service],
  EngagementLog: [EngagementKeys.topic],
  ContentLog: [ContentLogKeys.topic],
};

export default function TrackerTableHeaderRow({
  columns,
  type,
  tabColor,
  isBulkEdit = false,
  isBulkEditSelectedAll = false,
  isBulkEditSelectedIndeterminate = false,
  onBulkEditSelectAll = () => {},
  sortConfig = null,
  onSort = () => {},
}) {
  const { pathname } = useLocation();
  const theme = useTheme();
  const resolvedTabColor = tabColor ?? getTabColorHeaderMain(pathname, theme);
  const centerAlignedColumns = ['Status', 'Complexity', 'Tone'];

  const getTableRowCellSx = (col) => {
    const cellSx = {
      textAlign: 'left',
      padding: '10px 6px 10px 10px',
      color: 'white',
      fontSize: '14px',
      fontWeight: 700,
      width: 'auto',
      whiteSpace: 'nowrap',
      backgroundColor: resolvedTabColor,
      position: 'relative',
    };

    if (wide1ColsMap[type].includes(col)) {
      cellSx.width = '20%';
    } else if (wide2ColsMap[type].includes(col)) {
      cellSx.width = '40%';
    } else if (col === IssueAndServiceSharedValues.teamMembers) {
      cellSx.width = '15%';
    } else if (col === IssueAndServiceSharedValues.leadExpert) {
      cellSx.width = '10%';
    } else if (col === IssueAndServiceSharedValues.unit) {
      cellSx.width = '10%';
    } else if (
      col === IssueKeys.outlet ||
      col === EngagementKeys.organization ||
      col === ContentLogKeys.audience ||
      col === IssueAndServiceSharedValues.department
    ) {
      cellSx.width = '10%';
    }

    if (centerAlignedColumns.includes(col)) {
      cellSx.textAlign = 'center';
    }

    return cellSx;
  };

  const iconCellSx = {
    textAlign: 'left',
    padding: 0,
    color: 'white',
    fontSize: '14px',
    fontWeight: 700,
    width: '10px',
    whiteSpace: 'nowrap',
    backgroundColor: resolvedTabColor,
    position: 'relative',
    borderLeft: 'none',
    borderRight: 'none',
  };

  const sortLabelSx = {
    color: 'white',
    '&:hover': {
      color: 'white',
    },
    '&:not(.Mui-active) .MuiTableSortLabel-icon': {
      transform: 'none',
    },
    '&.Mui-active': {
      color: 'white',
    },
    '& .MuiTableSortLabel-icon': {
      color: theme.palette.grey[300],
      opacity: 1,
    },
    '&.Mui-active .MuiTableSortLabel-icon': {
      color: 'white',
      opacity: 1,
    },
  };

  let tableHeaderSecondCol = <TableCell sx={iconCellSx}></TableCell>;
  if (isBulkEdit) {
    tableHeaderSecondCol = (
      <TableCell sx={iconCellSx}>
        <Box sx={{ display: 'flex', width: '48px', height: '48px', alignItems: 'center', justifyContent: 'center' }}>
          <Checkbox
            color="default"
            indeterminate={isBulkEditSelectedIndeterminate}
            checked={isBulkEditSelectedAll}
            onChange={(e) => onBulkEditSelectAll(e.target.checked)}
          />
        </Box>
      </TableCell>
    );
  }

  return (
    <TableHead sx={{ height: '60px' }}>
      <TableRow>
        <TableCell sx={iconCellSx}></TableCell>
        {tableHeaderSecondCol}
        {columns.map((col) => {
          const isActive = sortConfig?.key === col;
          const direction = isActive ? sortConfig?.direction ?? 'asc' : 'asc';
          return (
            <TableCell key={col} sx={getTableRowCellSx(col)}>
              <TableSortLabel
                active={isActive}
                direction={direction}
                onClick={() => onSort(col)}
                hideSortIcon={false}
                IconComponent={isActive ? undefined : SwapVertIcon}
                sx={sortLabelSx}
              >
                {col}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
